import React, { useState, useEffect, } from 'react';

import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';

import DateRangePickerComponent from '../../components/date-range';
// import './../../assets/stylesheet/insights.scss';
import '../../assets/stylesheet/insights.scss'
import MyMultiSelectDropdown from "../../utilities/multiSelectInputType";
import '../../assets/stylesheet/multiSelectInputType.css';

import LineChart from '../../staticComps/lineChart';

// table-packege and data start
import ReactPaginate from 'react-paginate';
import StackedPercentageBarChart from '../../staticComps/stackedPercentageBarChart';
import Exporttools from '../../components/exporttools';
import Autocomplete from '../../components/autocomplete';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import GetUserData from '../../utilities/getUserDetails';
import ApiRequest from '../../services/apiService';
import baseUrl from '../../services/baseUrl';
import SummaryTab from './ResponseSummaryTab';
import ResponseSummaryTab from './ResponseSummaryTab';
import ResponseListTab from './ResponseListTab';
import SingleSelectTouchpointDropdown from '../Dashboard/DropDownSelectTouchpointInputType';
import SingleSelectSobDropDown from '../Dashboard/DropDownSelectSobInputType';
import ScreenLoader from '../../components/screenLoader';


function Response() {
  const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || "");
  const [viewFilter, setViewFilter] = useState('Summary');
  const [projects, setProjects] = useState([]);
  const [touchpointViewFilter, setTouchpointViewFilter] = useState("groupView");
  const [summaryLineChartData, setSummaryLineChartData] = useState([]);
  const [summaryBarChartData, setSummaryBarChartData] = useState([]);
  const [summaryTableData, setSummaryTableData] = useState([]);
  const [viewTableData, setViewTableData] = useState([]);
  const location = useLocation();
  const query = queryString.parse(location.search);
  const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
  const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
  const [isAllTouchPoints, setIsAllTouchpoints] = useState(
    (localStorage.getItem('touchpointFilter') || localStorage.getItem('isAllTouchpoints')) ? true : false
  );
  const [IsLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const params = new URLSearchParams({
        quickFilterRange: quickFilter,
        fromDate: localStorage.getItem('fromDate') || fromDate,
        toDate: localStorage.getItem('toDate') || toDate,
        projectFilter: projectFilter,
        userCode: GetUserData().UserCode,
        userRole: GetUserData().UserRole,
        viewFilter: viewFilter,
        touchpointFilter: touchpointFilter,
        sobFilter: sobFilter
      });
      const url = `${baseUrl()}/nps/GetNpsResponseData?${params.toString()}`;
      const response = await ApiRequest({ apiLink: url, method: 'GET' });
      if (response.Message === 'Success') {
        setIsLoading(false);

        setProjects(response.Data.Projects || []);
        setSummaryLineChartData(response.Data.SummaryLineChartData || []);
        setSummaryBarChartData(response.Data.SummaryBarChartData || []);
        setSummaryTableData(response.Data.SummaryTableData || []);
        setViewTableData(response.Data.ViewTableData || []);
      } else {
        console.log('Failed to load data');
      }
    } catch (error) {
      console.error('Error fetching cloud data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [quickFilter, projectFilter, fromDate, toDate, viewFilter, sobFilter, touchpointFilter]);

  const handleDateRangeFilter = (startDate, endDate) => {
    if (startDate && endDate) {
      setFromDate(startDate.toISOString().split("T")[0]);
      setToDate(endDate.toISOString().split("T")[0]);
      setQuickFilter("");
    } else {
      setFromDate("");
      setToDate("");
    }
    localStorage.setItem('quickFilter', '');
    localStorage.setItem('fromDate', startDate.toISOString().split("T")[0]);
    localStorage.setItem('toDate', endDate.toISOString().split("T")[0]);
  };
  //QuickFilters
  const handleQuickFilter = async (event) => {
    const selectedValue = event.target.value;
    setFromDate('');
    setToDate('');
    setQuickFilter(selectedValue);
    localStorage.setItem('fromDate', '');
    localStorage.setItem('toDate', '');
    localStorage.setItem('quickFilter', selectedValue);
    window.location.reload();

  };

  const handleViewSelect = (e) => {
    setTouchpointViewFilter(e.target.value);
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleTouchpointFilter = (touchpoint) => {
    setTouchpointFilter(touchpoint);
    localStorage.setItem("touchpointFilter", touchpoint);
  }
  const handleSobFilter = (sob) => {
    setSobFilter(sob);
    localStorage.setItem("sobFilter", sob);
  }

  const handleAllTouchpointSelect = (isSelected) => {
    setSobFilter('');
    setIsAllTouchpoints(isSelected);
  }
  const handleProjectFilter = (event) => {
    const selectedOption = event.target.value;
    setProjectFilter(selectedOption === "Select Project" ? '' : selectedOption);
    localStorage.setItem('projectFilter', selectedOption === "Select Project" ? '' : selectedOption);
    localStorage.removeItem("sobFilter");
    localStorage.removeItem("touchpointFilter");
    window.location.reload();
  };
  return (
    <>
      {IsLoading ? (
        <div className="screenLoader">
          <ScreenLoader />
        </div>
      ) : (
        <section className='container-fluid mt-1'>
          <div className='Page-title d-flex align-items-center mb-1'>
            <h3 className='mb-2'>Response</h3>
            <div className='ms-2 mb-1'>
              <select
                className="did-floating-select w-100px h-30"
                value={viewFilter}
                onChange={e => setViewFilter(e.target.value)}
              >
                <option value={""}>Select View</option>
                <option>Summary</option>
                <option>List</option>
              </select>
              <label className="did-floating-label">
                Select View
              </label>
            </div>
            <div className='me-2'>
              <div className="did-floating-label-content ms-1 mb-0">
                  <select
                    className="did-floating-select w-150px h-300"
                    value={projectFilter}
                    onChange={handleProjectFilter}
                  >
                    {/* <option value="">Select Project</option> */}
                    {projects.map((project) => (
                      <option key={project.ProjectId} value={project.ProjectId}>{project.ProjectName}</option>
                    ))}
                  </select>
                  <label className="did-floating-label">
                    Project Filter
                  </label>
                </div>
            </div>
            <div
              className="did-floating-label-content mb-1">
              <SingleSelectSobDropDown
                onSobSelect={handleSobFilter}
                onAllTouchpointSelect={handleAllTouchpointSelect}
              />
            </div>
            <div
              className={
                (!isAllTouchPoints)
                  ? "d-none did-floating-label-content mb-0"
                  : "did-floating-label-content mb-0"
              }>
              <SingleSelectTouchpointDropdown
                onTouchPointSelect={handleTouchpointFilter}
              />
            </div>
            <div className='card-option ms-auto d-flex'>
              <div className="did-floating-label-content me-2 mb-0">
                <select
                  className="did-floating-select w-100px h-30"
                  value={quickFilter}
                  onChange={handleQuickFilter}
                >
                  <option value={""}>Select Filter</option>
                  <option>FTD</option>
                  <option>WTD</option>
                  <option>MTD</option>
                  <option>QTD</option>
                  <option>YTD</option>
                </select>
                <label className="did-floating-label">
                  Quick Filter
                </label>
              </div>
              <div className='did-floating-label-content mb-0'>
                <DateRangePickerComponent
                  onRangeSelect={handleDateRangeFilter}
                  quickFilter={quickFilter} />
              </div>
            </div>
          </div>
          {/* chart area */}
          {viewFilter === 'Summary' ? (
            <>
              <ResponseSummaryTab lineChartData={summaryLineChartData} barChartData={summaryBarChartData} tableData={summaryTableData} />
            </>
          ) : ("")}

          {/* List (Highly Confidential) */}
          {viewFilter === 'List' ? (<>
            <ResponseListTab tableData={viewTableData} />
          </>) : ("")}
        </section>
      )}
    </>
  )
}

export default Response;
